/** Navigation — v3 header interactions */

export function initNavigation(): void {
  const nav = document.querySelector<HTMLElement>('.g-nav')
  const menuToggle = document.getElementById('menu-toggle')
  const header = document.querySelector<HTMLElement>('.g-header')
  const bttb = document.getElementById('bttb')

  if (!nav || !header) return

  const setMenuOpen = (open: boolean) => {
    nav.classList.toggle('show', open)
    menuToggle?.setAttribute('aria-expanded', open ? 'true' : 'false')
  }

  menuToggle?.setAttribute('aria-expanded', 'false')
  menuToggle?.setAttribute('role', 'button')
  menuToggle?.setAttribute('aria-label', document.documentElement.lang.startsWith('en') ? 'Open navigation menu' : '打开导航菜单')

  menuToggle?.addEventListener('click', (e) => {
    e.stopPropagation()
    setMenuOpen(!nav.classList.contains('show'))
  })

  nav.addEventListener('click', (e) => e.stopPropagation())

  document.addEventListener('click', () => setMenuOpen(false))
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setMenuOpen(false)
  })

  // Dropdown menus (if any remain)
  document.querySelectorAll('.g-nav li.dropdown').forEach((li) => {
    li.addEventListener('click', (e) => {
      e.stopPropagation()
      document.querySelectorAll('.g-nav li.dropdown').forEach((other) => {
        if (other !== li) {
          other.querySelector('.dropdown-toggle')?.classList.remove('show')
          other.querySelector('.dropdown-menu')?.classList.remove('show')
        }
      })
      li.querySelector('.dropdown-toggle')?.classList.toggle('show')
      li.querySelector('.dropdown-menu')?.classList.toggle('show')
    })
  })

  document.addEventListener('click', () => {
    document.querySelectorAll('.g-nav li.dropdown').forEach((li) => {
      li.querySelector('.dropdown-toggle')?.classList.remove('show')
      li.querySelector('.dropdown-menu')?.classList.remove('show')
    })
  })

  // Back-to-top visibility only (header stays sticky glass)
  let lastScrollTop = window.scrollY
  window.addEventListener(
    'scroll',
    () => {
      const scrollTop = window.scrollY
      header.classList.toggle('nav-scrolled', scrollTop > 8)

      if (scrollTop > 240 && lastScrollTop > scrollTop) {
        bttb?.classList.add('active')
      } else if (scrollTop < 120) {
        bttb?.classList.remove('active')
      } else if (scrollTop > lastScrollTop) {
        bttb?.classList.remove('active')
      }
      lastScrollTop = scrollTop
    },
    { passive: true },
  )
}
